import axios from 'axios';
import { Url } from './constantUrl';
import getHeaders from './getHeaders';
import * as types from './types';
import { errorHandler } from './error/errorHandler.action';

// Get Target vs Achievement List with pagination and search
export const getTargetAchievementListAction = (page, pageSize, aps_code) => dispatch => {
  const url = `${process.env.REACT_APP_API_URL}${Url.TARGET_ACHIEVEMENT_LIST}/${aps_code}?page_size=${pageSize}&page=${page}`;
  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url
  };

  return axios(options)
    .then(response => {
      if (response.status === 200) {
        dispatch({ type: types.GET_TARGET_ACHIEVEMENT_LIST, payload: response });
        return response;
      } else {
        return null;
      }
    })
    .catch(error => {
      errorHandler(error);
      throw error;
    });
};

// Download Target vs Achievement Excel
export const downloadTargetAchievementExcelAction = (query = '', aps_code = '') => dispatch => {
  const url = `${process.env.REACT_APP_API_URL}${Url.TARGET_ACHIEVEMENT_DOWNLOAD}/${aps_code}?download=true${query ? `&${query}` : ''}`;

  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url,
    responseType: 'blob'
  };

  return axios(options)
    .then(response => {
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch(error => {
      errorHandler(error);
      throw error;
    });
};

// Get APS list for logged-in Area Head
export const getAPSListAction = () => dispatch => {
  const url = `${process.env.REACT_APP_API_URL}${Url.APS_LIST}`;
  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url
  };

  return axios(options)
    .then(response => {
      if (response.status === 200) {
        dispatch({ type: types.GET_APS_LIST, payload: response });
        return response;
      } else {
        return null;
      }
    })
    .catch(error => {
      errorHandler(error);
      throw error;
    });
};

// Get customers/retailers for selected APS
export const getAPSCustomersAction = (apsCode) => dispatch => {
  const url = `${process.env.REACT_APP_API_URL}${Url.APS_CUSTOMERS}?aps=${apsCode}`;
  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url
  };

  return axios(options)
    .then(response => {
      if (response.status === 200) {
        dispatch({ type: types.GET_APS_CUSTOMERS, payload: response });
        return response;
      } else {
        return null;
      }
    })
    .catch(error => {
      errorHandler(error);
      throw error;
    });
};

// Get customer detail plan vs actual
export const getCustomerDetailAction = (customerCode, apsCode) => dispatch => {
  const url = `${process.env.REACT_APP_API_URL}${Url.CUSTOMER_TARGET_DETAIL}?customer_code=${customerCode}&aps=${apsCode}`;
  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url
  };

  return axios(options)
    .then(response => {
      if (response.status === 200) {
        dispatch({ type: types.GET_CUSTOMER_TARGET_DETAIL, payload: response });
        return response;
      } else {
        return null;
      }
    })
    .catch(error => {
      errorHandler(error);
      throw error;
    });
};

// Get customer detail list for a specific month (new detail page)
export const getCustomerDetailListAction = (apsCode, month, page, pageSize, queryParam = '') => dispatch => {
  let query = `?page=${page}&page_size=${pageSize}`;
  if (queryParam) {
    // queryParam can be "customer_code=xxx" or "customer_name=xxx"
    query += `&${queryParam}`;
  }

  const url = `${process.env.REACT_APP_API_URL}${Url.CUSTOMER_DETAIL_LIST}/${apsCode}/${month}${query}`;
  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url
  };

  return axios(options)
    .then(response => {
      if (response.status === 200) {
        dispatch({ type: types.GET_CUSTOMER_DETAIL_LIST, payload: response });
        return response;
      } else {
        return null;
      }
    })
    .catch(error => {
      errorHandler(error);
      throw error;
    });
};

// Download customer detail Excel for a specific month
export const downloadCustomerDetailExcelAction = (apsCode, month, queryParam = '') => dispatch => {
  let query = '';
  if (queryParam) {
    // queryParam can be "customer_code=xxx" or "customer_name=xxx"
    query += `&${queryParam}`;
  }

  const url = `${process.env.REACT_APP_API_URL}${Url.CUSTOMER_DETAIL_DOWNLOAD}/${apsCode}/${month}?download=true${query ? `${query}` : ''}`;

  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url,
    responseType: 'blob'
  };

  return axios(options)
    .then(response => {
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch(error => {
      errorHandler(error);
      throw error;
    });
};

// Set selected APS and its data
export const setSelectedAPSAction = (apsCode, dataList, totalCount, currentPage) => dispatch => {
  dispatch({
    type: types.SET_SELECTED_APS,
    payload: {
      selectedAPS: apsCode,
      dataList: dataList,
      totalCount: totalCount,
      currentPage: currentPage
    }
  });
};

// Clear selected APS data
export const clearSelectedAPSAction = () => dispatch => {
  dispatch({
    type: types.CLEAR_SELECTED_APS
  });
};

// Get single customer plan vs actual detail
export const getSingleCustomerDetailAction = (customerCode) => dispatch => {
  const url = `${process.env.REACT_APP_API_URL}${Url.SINGLE_CUSTOMER_DETAIL}/${customerCode}`;
  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url
  };

  return axios(options)
    .then(response => {
      if (response.status === 200) {
        return response;
      } else {
        return null;
      }
    })
    .catch(error => {
      errorHandler(error);
      throw error;
    });
};

// Set customer detail page state for persistence
export const setCustomerDetailStateAction = (apsCode, month, searchField, searchValue, currentPage, dataList, totalCount) => dispatch => {
  dispatch({
    type: types.SET_CUSTOMER_DETAIL_STATE,
    payload: {
      apsCode,
      month,
      searchField,
      searchValue,
      currentPage,
      dataList,
      totalCount
    }
  });
};

// Clear customer detail page state
export const clearCustomerDetailStateAction = () => dispatch => {
  dispatch({
    type: types.CLEAR_CUSTOMER_DETAIL_STATE
  });
};
